import clsx from 'clsx'
import {Action} from '../types'
import {FC, useMemo} from 'react'
import {Link} from 'react-router-dom'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {actionDefaultColor, actionDefaultIcon, actionDefaultLabel} from '../utils'

const ActionButton: FC<{action: Action; row: any}> = ({action, row}) => {
  const intl = useIntl()

  const defaultLabel = actionDefaultLabel(action.type)
  const defaultIcon = actionDefaultIcon(action.type)
  const defaultColor = actionDefaultColor(action.type)

  const color = action.color || defaultColor
  const icon = action.icon || defaultIcon
  const label = action.label || defaultLabel

  const className = clsx(
    'btn',
    'btn-sm',
    'm-1',
    {
      [`btn-${color}`]: !!color,
      'btn-icon': !!icon,
    },
    action.className
  )
  let renderedButton = null
  let labelComponent = null

  const id = `${Math.random()}`

  const labelHasTranslation = label ? !!intl.messages[label] : false
  const labelTranslation = label && labelHasTranslation ? intl.$t({id: label}) : label

  const renderTooltip = useMemo(() => {
    return <Tooltip id={`tooltip-${id}`}>{labelTranslation}</Tooltip>
  }, [id, labelTranslation])

  if (icon) {
    labelComponent = <i className={icon} />
  } else {
    labelComponent = labelTranslation
  }

  if (action.to) {
    renderedButton = (
      <Link
        to={typeof action.to === 'function' ? action.to(row) : action.to}
        className={className}
        state={row}
      >
        {labelComponent}
      </Link>
    )
  }
  if (typeof action.onClick === 'function') {
    renderedButton = (
      <button type='button' className={className} onClick={() => action.onClick?.(row)}>
        {labelComponent}
      </button>
    )
  }

  if (!renderedButton) return null

  return <OverlayTrigger overlay={renderTooltip}>{renderedButton}</OverlayTrigger>
}

export default ActionButton
